const moveTaxWrapper = () => {
  console.log('11111')
  const taxWrapper = document.querySelector('.bss-b2b-tax-ex-wrapper');
  const cartPageCol = document.querySelector('.cart__page-col:nth-child(2)');

  if (taxWrapper && cartPageCol && taxWrapper.parentElement !== cartPageCol) {
    cartPageCol.prepend(taxWrapper);
  }
};

moveTaxWrapper();

const observer = new MutationObserver(moveTaxWrapper);
observer.observe(document.body, {
  childList: true,
  subtree: true,
});